import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { Draft, DraftStatus, DraftStatusFactory, DraftStatusKeys } from '../db/Draft.js';

/**
 * Setzt den Status eines Entwurfs auf einen neuen Status.
 *
 * @throws {Error} Wenn der Entwurf nicht gefunden wird.
 */
export const changeDraftStatus = registerMutation({
  type: () => String,
  operationName: 'changeDraftStatus',
  resolve: (draftID: string, status: keyof typeof DraftStatusKeys) => {
    return async () => {
      const rawDraftCollection = await getRawCollection<Draft>(Draft._collectionName);
      await rawDraftCollection.updateOne(
        { _id: draftID },
        { $set: { status: DraftStatusFactory.create(status).toObject() as any as DraftStatus } },
      );
    };
  },
  params: [
    { name: 'draftID', type: () => String },
    { name: 'status', type: () => String },
  ],
});
